import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { supabase } from '../../utils/supabase';
import AuthAside from './AuthAside';
import './AuthPages.css';

/** Affiche la demande de récupération et confie à Supabase la création du lien sécurisé. */
export default function ForgotPasswordForm() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  /** Envoie le lien vers la page dédiée et affiche une réponse qui ne révèle pas l'existence du compte. */
  async function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    setError('');
    setSent(false);
    try {
      const { error: sendError } = await supabase.auth.resetPasswordForEmail(email.trim(), {
        redirectTo: `${window.location.origin}/reset-password`,
      });
      if (sendError) throw sendError;
      setSent(true);
    } catch (sendError) {
      setError(sendError?.status === 429
        ? 'Trop de demandes. Réessayez dans quelques minutes.'
        : 'Impossible d’envoyer le lien. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  }

  /** Conserve la saisie et efface le résultat précédent pour permettre une nouvelle demande. */
  function handleEmailChange(event) {
    setEmail(event.target.value);
    setError('');
    setSent(false);
  }

  return (
    <div className="auth-page">
      <div className="auth-shell">
        <AuthAside titre="Retrouvez l’accès à votre" motCle="compte" points={['Recevez un lien personnel par email', 'Choisissez ensuite un nouveau mot de passe']} />
        <section className="auth-card">
          <h2>Mot de passe oublié ?</h2>
          <p className="auth-sub">Indiquez l’adresse email utilisée pour votre compte.</p>
          <form className="auth-form" onSubmit={handleSubmit} aria-busy={loading}>
            {error && <div className="auth-alert auth-alert-error" role="alert">{error}</div>}
            {sent && <div className="auth-alert auth-alert-success" role="status">Si un compte correspond à cette adresse, vous recevrez un lien de réinitialisation. Vérifiez aussi vos courriers indésirables.</div>}
            <label className="auth-label" htmlFor="recovery-email">Email</label>
            <div className="auth-field">
              <EnvelopeIcon className="auth-field-icon" aria-hidden="true" />
              <input id="recovery-email" type="email" autoComplete="email" required value={email} onChange={handleEmailChange} disabled={loading} />
            </div>
            <button className="auth-btn auth-btn-accent" type="submit" disabled={loading}>{loading ? 'Envoi en cours…' : 'Recevoir le lien'}</button>
          </form>
          <p className="auth-switch"><Link to="/login">Retour à la connexion</Link></p>
        </section>
      </div>
    </div>
  );
}
